import React from "react";
import Breadcrumb from "../components/Breadcrumb";
import FooterOne from "../components/FooterOne";
import NavBar from "../components/NavBar";
import TermsConditionDetails from "../components/TermsConditionDetails";

const TermsCondition = () => {
  return (
    <>
      {/* Navigation Bar */}
      <NavBar />

      {/* Navigation Bar */}
      <Breadcrumb title={"Terms And Condition"} />

      {/* Service Details Area */}
      <TermsConditionDetails/>
      
      


      {/* Footer One */}
      <FooterOne />
    </>
  );
};

export default TermsCondition;
